import { mapActions, mapState, mapGetters } from 'vuex'
import { Datatable } from '@argon/app/mixins'
import { NAMESPACE as ME_NAMESPACE } from '@argon/iam/me/store'
import { NAMESPACE as ENTITY_NAMESPACE } from '@argon/evo/entities/store'
import { NAMESPACE as REALTIME_NAMESPACE } from '@argon/realtime/store'
import { NAMESPACE } from '../store'
import { BaseForm } from '@argon/app/components'
import entityPerimeter from '@argon/evo/entities/perimeters'

export default {
  name: 'AddonMixin',
  extends: BaseForm,
  mixins: [Datatable],
  props: {
    boardItem: {
      type: Object,
      required: true
    },
    enableOwner: { type: Boolean, default: false },
    enablePrivate: { type: Boolean, default: false },
    readOnly: { type: Boolean, default: false },
    label: String
  },
  perimeters: [entityPerimeter],
  data: () => ({
    loading: true,
    alertMessage: null,
    editingId: null,
    form: {},
    itemsPerPage: 5,
    itemsPerPageArray: [5, 10, 20, -1]
  }),
  computed: {
    ...mapState(ME_NAMESPACE, ['userId']),
    ...mapGetters(ME_NAMESPACE, ['timezone', 'locale']),
    ...mapState(ENTITY_NAMESPACE, ['principals']),
    ...mapState(NAMESPACE, ['items', 'itemsCount']),
    alert: {
      get() {
        return !!this.alertMessage
      },
      set(v) {
        this.alertMessage = v
      }
    },
    entity() {
      return this.boardItem.entity
    },
    proxyURL() {
      return `/boards/${this.boardItem.board_refname}/items/${this.entity.id}`
    },
    entityURL() {
      return this.boardItem.entity.uris.self
    },
    matches() {
      return this.items[this.addonName] || []
    },
    matchesCount() {
      return this.$store.getters[`${NAMESPACE}/itemsCount`](this.addonName)
    },
    hasMatches() {
      return this.matches.length > 0
    },
    canEdit() {
      return !this.readOnly && this.$entity.isAllowed('update', this.entity)
    },
    canManage() {
      return this.$entity.isAllowed('manage', this.entity)
    },
    useOwner() {
      return this.enableOwner && this.canManage
    },
    members() {
      return this.principals.filter((x) => !!x.user).map((x) => ({ ...x, ...x.user }))
    },
    realtimeKey() {
      return this.$store.getters[`${REALTIME_NAMESPACE}/realtimeKey`]({
        category: `${this.addonName}Addons`,
        identifier: this.entity.refid
      })
    }
  },
  methods: {
    ...mapActions(REALTIME_NAMESPACE, ['addListener', 'removeListenerCategory']),
    ...mapActions(NAMESPACE, [
      'listEntityAddons',
      'clearAddons',
      'createEntityAddon',
      'updateEntityAddon',
      'deleteEntityAddon',
      'uploadFile',
      'listLabels'
    ]),
    resetForm() {
      this.editingId = null
      this.form = {}
    },
    buildData() {
      return this.form
    },
    loadData(instance) {
      this.editingId = instance.id
      this.form = { ...instance }
    },
    canEditItem(instance) {
      return this.canEdit
    },
    _add(data) {
      return this.createEntityAddon({
        entityURL: this.entity.uris.self,
        addon: this.addonName,
        data
      }).then(() => {
        this.page = 1
        this.fetchData()
      })
    },
    _edit(data) {
      return this.updateEntityAddon({
        id: this.editingId,
        entityURL: this.entity.uris.self,
        addon: this.addonName,
        data
      }).then(() => {
        this.editingId = null
        this.fetchData()
      })
    },
    add() {
      this.loading = true
      this.resetServerErrors()
      if (!this.$v.form.$invalid) {
        let data = this.buildData()
        const callback = this.editingId ? this._edit : this._add
        callback(data).finally(() => {
          this.loading = false
        })
        // .catch(this.setServerErrors)
      } else {
        this.$v.form.$touch()
        this.loading = false
      }
    },
    update(instance, data) {
      this.loading = true
      this.updateEntityAddon({
        id: instance.id,
        entityURL: this.entity.uris.self,
        addon: this.addonName,
        data
      })
        .then(() => {
          this.fetchData()
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(instance) {
      this.loading = true
      this.deleteEntityAddon({
        id: instance.id,
        entityURL: this.entity.uris.self,
        addon: this.addonName
      })
        .then(() => {
          this.page = 1
          this.fetchData()
        })
        .catch(() => {
          this.alertMessage = 'deleteError'
        })
    },
    log() {
      //
    },
    fetchData() {
      this.loading = true
      let payload = {
        refid: this.entity.refid,
        entityURL: this.entityURL,
        addon: this.addonName,
        pager: this.pager
      }
      return this.listEntityAddons(payload).finally(() => {
        this.loading = false
        this.resetForm()
      })
    }
  },
  watch: {
    realtimeKey: function (v, oldV) {
      if (oldV) {
        this.fetchData()
      }
    }
  },
  created() {
    this.addListener({
      category: `${this.addonName}Addons`,
      identifier: this.entity.refid
    })
  },
  destroyed() {
    this.clearAddons({ addon: this.addonName })
    this.removeListenerCategory(`${this.addonName}Addons`)
  }
}
